import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const IntelliJLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.8 16.9274L0.27 14.1399L2.3475 10.2924L5.47 11.3374L3.8 16.9274Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path d="M24 6.39746L23.5675 20.2975L14.3225 24L9.2875 20.75L24 6.39746Z" fill="#087CFA" />
            <path
                d="M24 6.39746L19.425 10.86L13.55 3.65246L16.45 0.392456L24 6.39746Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M9.2875 20.75L1.935 23.4075L3.475 18.015L5.47 11.3375L0 9.5075L3.475 0L11.33 0.9275L19.425 10.86L9.2875 20.75Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M4.6075 4.5H19.6075V19.5H4.6075V4.5Z" fill="black" />
            <path d="M6.4775 16.6649H12.1025V17.6024H6.4775V16.6649Z" fill="white" />
            <path
                d="M9.285 7.40488V6.37988H6.4875V7.40488H7.2725V10.9449H6.4875V11.9699H9.285V10.9449H8.5025V7.40488H9.285Z"
                fill="white"
            />
            <path
                d="M11.9675 12.0499C11.5863 12.0622 11.2083 11.9761 10.87 11.7999C10.5921 11.6503 10.3446 11.4502 10.14 11.2099L10.9125 10.3474C11.0536 10.5066 11.217 10.6447 11.3975 10.7574C11.5588 10.8574 11.7452 10.9094 11.935 10.9074C12.0365 10.9123 12.1379 10.8954 12.2323 10.8579C12.3267 10.8204 12.412 10.7631 12.4825 10.6899C12.6331 10.4863 12.7042 10.2347 12.6825 9.98238V6.37488H13.9325V10.0374C13.9381 10.334 13.8915 10.6293 13.795 10.9099C13.7128 11.1431 13.5784 11.3544 13.4021 11.5277C13.2257 11.701 13.0121 11.8317 12.7775 11.9099C12.5111 12.0001 12.2312 12.044 11.95 12.0399"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="1.7725"
                    y1="13.6774"
                    x2="13.7175"
                    y2="13.0699"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.09" stopColor="#FC801D" />
                    <stop offset="0.23" stopColor="#B07F61" />
                    <stop offset="0.41" stopColor="#577DB3" />
                    <stop offset="0.53" stopColor="#1E7CE6" />
                    <stop offset="0.59" stopColor="#087CFA" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="21.245"
                    y1="12.405"
                    x2="17.2625"
                    y2="0.504956"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE2857" />
                    <stop offset="0.08" stopColor="#CB3979" />
                    <stop offset="0.16" stopColor="#9E4997" />
                    <stop offset="0.25" stopColor="#7557B2" />
                    <stop offset="0.34" stopColor="#5362C8" />
                    <stop offset="0.44" stopColor="#386CDA" />
                    <stop offset="0.54" stopColor="#2373E8" />
                    <stop offset="0.66" stopColor="#1478F2" />
                    <stop offset="0.79" stopColor="#0B7BF8" />
                    <stop offset="1" stopColor="#087CFA" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="3.6625"
                    y1="5.5275"
                    x2="18.6825"
                    y2="30.3725"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE2857" />
                    <stop offset="0.08" stopColor="#FE295F" />
                    <stop offset="0.21" stopColor="#FF2D76" />
                    <stop offset="0.3" stopColor="#FF318C" />
                    <stop offset="0.38" stopColor="#EA3896" />
                    <stop offset="0.55" stopColor="#B248AE" />
                    <stop offset="0.79" stopColor="#5A63D6" />
                    <stop offset="1" stopColor="#087CFA" />
                </linearGradient>
            </defs>
        </svg>
    );
};
